import React, { useState, useEffect } from 'react';
import { blogPosts, getCategories } from '../contexts/BlogContext';
import { useLanguage } from '../contexts/LanguageContext';
import { useNavigate } from 'react-router-dom';
import '../styles/Blog.css';

const Blog = () => {
  const { language } = useLanguage();
  const isRtl = language === 'he';
  const navigate = useNavigate ? useNavigate() : (url) => { window.location.href = url };
  
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [filteredPosts, setFilteredPosts] = useState(blogPosts);
  const categories = getCategories(language);

  useEffect(() => {
    if (selectedCategory === 'all') {
      setFilteredPosts(blogPosts);
    } else {
      setFilteredPosts(blogPosts.filter(post => post.category[language] === selectedCategory));
    }
  }, [selectedCategory, language]);

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
  };

  const getCategoryLabel = () => {
    switch (language) {
      case 'he':
        return 'קטגוריות';
      case 'fr':
        return 'Catégories';
      case 'es':
        return 'Categorías';
      default:
        return 'Categories';
    }
  };

  const getAllLabel = () => {
    switch (language) {
      case 'he':
        return 'הכל';
      case 'fr':
        return 'Tous';
      case 'es':
        return 'Todos';
      default:
        return 'All';
    }
  };

  return (
    <main className={`blog-main${isRtl ? ' rtl-text' : ''}`}>
      
      {/* Background Pattern */}
      <div className="blog-background-pattern" />

      <div className="blog-header">
        <h1 className="blog-main-title">
          {language === "he" ? "בלוג תיירות" : 
           language === "fr" ? "Blog Tourisme" : 
           language === "es" ? "Blog de Turismo" : "Tourism Blog"}
        </h1>
      </div>

      {/* Categories Filter */}
      <div className="blog-categories">
        <div className="blog-categories-label">{getCategoryLabel()}</div>
        <div className="blog-categories-container">
          <button 
            className={`blog-category-button ${selectedCategory === 'all' ? 'active' : ''}`}
            onClick={() => handleCategoryChange('all')}
          >
            {getAllLabel()}
          </button>
          {categories.map((category) => (
            <button 
              key={category}
              className={`blog-category-button ${selectedCategory === category ? 'active' : ''}`}
              onClick={() => handleCategoryChange(category)}
            >
              {category}
            </button>
          ))}
        </div>
      </div>

      <div className="blog-grid">
        {filteredPosts.map((post) => (
          <div 
            key={post.id}
            className="blog-grid-card"
          >
            <a 
              href={`/blog/${post.id}`}
              className="blog-grid-link"
              onClick={(e) => {
                e.preventDefault();
                navigate(`/blog/${post.id}`);
              }}
              aria-label={post.title[language]}
            >
              <img 
                src={post.image} 
                alt={post.title[language]} 
                className="blog-grid-image"
              />
              <div className="blog-grid-content">
                <div className="blog-grid-category">
                  {post.category[language]}
                </div>
                <h2 className="blog-grid-title">
                  {post.title[language]}
                </h2>
                <p className="blog-grid-summary">
                  {post.summary[language]}
                </p>
                <button
                  className="blog-grid-readmore"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/blog/${post.id}`);
                  }}
                  aria-label={language === "he" ? "קרא עוד" : 
                             language === "fr" ? "Lire plus" : 
                             language === "es" ? "Leer más" : "Read more"}
                >
                  {language === "he" ? "קרא עוד" : 
                   language === "fr" ? "Lire plus" : 
                   language === "es" ? "Leer más" : "Read more"}
                </button>
              </div>
            </a>
          </div>
        ))}
      </div>
    </main>
  );
};

export default Blog;